/**************************************************************************
 * Created on Feb 24 2026
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 ********************************************************************************/

import React, { useEffect, useCallback } from 'react';
import DSSButton from '../../../ui/building-blocks/atoms/dss-button';
import DSSModal from '../../../ui/building-blocks/atoms/dss-modal';
import { useSession } from '../../providers/session-provider/session-provider';
import Timer from '../timer/timer';
import useAuth from '../../hooks/useAuth';

export default function SessionAlert() {
  const { logout } = useAuth();
  const { showSessionAlert, handleReactivate, stopTimer } = useSession();

  const handleSessionExpired = useCallback(() => {
    stopTimer();
    logout();
  }, [logout, stopTimer]);

  useEffect(() => {
    window.addEventListener('session-expired', handleSessionExpired);
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, [handleSessionExpired]);

  const handleLogout = useCallback(() => {
    stopTimer();
    handleReactivate();
    logout();
  }, [stopTimer, handleReactivate, logout]);

  return (
    <DSSModal
      id="session-alert-modal"
      isOpen={showSessionAlert}
      isShowClose={false}
      style={{
        textAlign: 'center',
        width: '30%',
        paddingTop: '10px',
        minWidth: "500px"
      }}
    >
      <div className='session-alert-content'>
        <h4>You have been Inactive For a While</h4>
        <div>
          <p style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
            Your session will expire in: <Timer key={showSessionAlert ? 'active' : 'inactive'} seconds={60} />
          </p>
        </div>
        <div>
          <p>Click <strong>Continue</strong> to extend your session.</p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', marginTop: '20px',marginBottom: '10px' }}>
          <DSSButton
            id='session-continue-btn'
            variant='secondary'
            style={{
              width: "80%",
              height: "3rem"
            }}
            onClick={handleReactivate}
          >
            Continue
          </DSSButton>

          <DSSButton
            id='session-logout-btn'
            variant='primary'
            style={{
              width: "80%",
              height: "3rem"
            }}
            onClick={handleLogout}
          >
            Logout
          </DSSButton>
        </div>
      </div>
    </DSSModal>
  );
}
